import { Outlet } from 'react-router-dom';

function Auth() {
    return (
        <div>
            <Outlet />
        </div>
    );
}

export default Auth;
